const Spinner = {
    baseStyle: {
        color: 'blue.500',
    },
};

export default Spinner;
